import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppRoutingModule } from './app-routing.module';

import { AppSharedUIModule } from 'app-shared-ui';
import {
  BaseService,
  DoctorService,
  FilterService,
  AssetsRegistrationService,
  UIUtilService,
  UserService,
} from 'app-service';
import { TranformService, TranslocoRootModule } from 'app-core';

import { InterceptorsModule } from './interceptors/interceptors.module';

import { AboutModule } from './about/about.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { SearchModule } from './search-home/search.module';
import { AppointmentModule } from './appointments/appointments.module';
import { OrganizationModule } from './organization/organization.module';
import { provideOpenTelemetry } from 'src/instrument';

@NgModule({
  declarations: [AppComponent, HomeComponent],
  imports: [
    BrowserModule,
    AboutModule,
    AppointmentModule,
    AppRoutingModule,
    AppSharedUIModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OrganizationModule,
    SearchModule,
    TranslocoRootModule,
    InterceptorsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    AssetsRegistrationService,
    BaseService,
    DoctorService,
    FilterService,
    TranformService,
    UIUtilService,
    UserService,

    //provideOpenTelemetry(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
